import { render, staticRenderFns } from "./sellOrderRulesForm.vue?vue&type=template&id=80eaec3c&scoped=true"
import script from "./sellOrderRulesForm.vue?vue&type=script&lang=js"
export * from "./sellOrderRulesForm.vue?vue&type=script&lang=js"
import style0 from "./sellOrderRulesForm.vue?vue&type=style&index=0&id=80eaec3c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80eaec3c",
  null
  
)

export default component.exports